import { GatsbyImage, StaticImage, getImage } from "gatsby-plugin-image";
import React from "react";
import { AppStoreButton } from "../AppStoreButton";
import { useStaticQuery, graphql } from "gatsby";

export const DownloadAppCallToAction = () => {
  const rawData = useStaticQuery(graphql`
    query {
      sanityBasicSettings {
        appQRCode {
          asset {
            gatsbyImageData(height: 80, width: 80)
          }
        }
        qrLabel
        androidAppUrl
        iosAppUrl
      }
    }
  `);

  const data = rawData.sanityBasicSettings;

  return (
    <div className="flex-col flex items-center min-w-fit">
      <div className="flex space-x-6 mb-6">
        <GatsbyImage
          image={getImage(data.appQRCode.asset)!}
          className="rounded-lg border border-transparent"
          alt="download-app"
        />
        <div className="text-3xl w-44">{data.qrLabel}</div>
      </div>
      <div className="flex items-center space-x-6">
        <AppStoreButton type="apple" />
        <AppStoreButton type="google" />
      </div>
    </div>
  );
};
